<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#cat"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title text-color-red2">Заблокировать контакт?</div>

              <p class="info-text text-color-red2">
                 Контакт будет перемещен в «Не работаем»,<br>вернуть можно будет через администратора.
              </p>
          </div>

          <div class="mt24">
             <submit-btn @click.native="userDelete" :type="btnType"><span class="i mr4" style="margin-top: -2px;" :class="{'i-ok7': btnType=='normal'}"></span>Подтвердить</submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';

    export default {
        name: "DismissContact",
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.dismissContact.name});
            },
            userDelete(){
                this.btnType = 'load';
                this.$store.dispatch('contacts/contactBlock', {id: this.editContact.id}).then(()=>{
                    this.btnType = 'normal';
                    this.$store.dispatch('contacts/getContacts');
                    setTimeout(()=>{
                        this.$store.commit('popups/close', {name: this.popups.dismissContact.name});
                    }, 100);
                });
            }
        },
        data(){
           return {
               btnType: 'normal'
           }
        },
        components:{
            SubmitBtn,
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                editContact: state => state.contacts.editContact,
            }),
        }
    }
</script>

<style scoped>

</style>
